export default __webpack_public_path__ + "static/media/gallery_03.2c277f18.jpg";